/* eslint-disable */
require('./backgrounds')
require('./dmds-logo')
require('./guide-graphics')
require('./hospital-logo-white-bg')
require('./icons')
require('./loaders')
require('./locales')
require('./logo')
require('./map-navigation')
require('./navigation')
require('./player')
require('./qr-bg')
require('./qr-support')
require('./qr')
require('./services')
